import React, { useEffect,useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoutes from "./routes/protected-routes";
import PublicRoutes from "./routes/public-route";
import { protectedRoutes, publicRoutes } from "./routes/routes";
import NotFound from "./components/not-found";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.scss";
import "antd/dist/antd.min.css";
import userServiceApi from "./api/userServiceApi";
import { getRequest } from "./api/http";
import { setMicroSites } from "./store/actions";
import { useStore } from "./store";
import "react-phone-number-input/style.css";

function App() {
  // const token = localStorage.getItem("token")
  const [token, setToken] = useState(localStorage.getItem("token"));
  const partner = localStorage.getItem("partner");


  const { dispatch } = useStore()
  const getMicrosites = async () => {

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await getRequest(userServiceApi.getAllMicrosites(), {
      headers,
    });
    if (response && response.data) {
      dispatch(setMicroSites(response?.data))
    }

  }

  useEffect(() => {
  if (!token) return;  // no token → do not call
  getMicrosites();     // token exists → safe API call
}, [token]);


  useEffect(() => {
  const storedToken = localStorage.getItem("token");
  setToken(storedToken);
}, []);
  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route path="/" element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => {
            return <><Route path={route.path} element={route.component} /></>
          })}
        </Route>

        {publicRoutes.map((route) => {
          return (
            <Route path={route.path} element={<PublicRoutes />}>
              <Route path={`/${route.path}`} element={route.component} />
            </Route>
          );
        })}
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <ToastContainer /> */}
    </Router>
  );
}

export default App;
